import React, { useEffect, useRef, useState } from 'react'
import Loader from '../../../ReUsableComponent/Loader'
import CustomFilterSearchDropdown from '../../../ReUsableComponent/CustomFilterSearchDropdown'
import dropDownIcon from '../../../assets/svg/dropDownIcon.svg';
import { GetBrandNameList } from '../../RuleManagement/RuleManagement.service';
import { useDispatch, useSelector } from 'react-redux';
import { stockActions } from '../../../store/reducers/StockOverviewReducer';
import { useHistory } from 'react-router-dom';
import { ToastErrorService, ToastSuccessService } from '../../../ReUsableComponent/ToastNotification/ToastService';
import DownloadIcon from '../../../assets/svg/blueDownload.svg';
import ImportIcon from '../../../assets/svg/uploadIcon.svg';
import { DownlaodStockBrokenSizeReport, GetReplenishmentFile, getStockFilterValue, UploadBrokenSizeFile } from '../StockOverview.service';
import CustomTableWithFilter from '../../../ReUsableComponent/CustomTableWithFilter';
import { StockBrokenSizeHeader } from '../../TableHeaders';
import CustomModal from '../../../ReUsableComponent/CustomModal';
import MultiSelectCheckBox from '../../../ReUsableComponent/MultiSelectCheckBox';
import CustomBlueButton from '../../../ReUsableComponent/CustomBlueButton';
import CloseIcon from '../../../assets/svg/closeIconofmodal.svg';
import CustomDropzone from '../../../ReUsableComponent/CustomDropzone';
import SecondaryButton from '../../../ReUsableComponent/SecondaryButton';
import ProgressBarForFileUpload from '../../../ReUsableComponent/ProgressBarForFileUpload';
import CustomAutoComplete from '../../../ReUsableComponent/CustomAutocomplete';
import { DownloadConsolidatedReportList } from '../../SalesOverview/SalesOverview.service';

const uploadedFileModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 835,
    bgcolor: '#F2F2F2',
    boxShadow: 24,
    p: '40px 32px',
    borderRadius: 6,
    border: '1px solid #3333330D'
};
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 300,
            width: 'max-content',
        },
    },
};

const BrokenSize = () => {
    const defaultBrand = useSelector(state => state.stock.defaultBrand);
    const [brandList, setBrandList] = useState([]);
    const [regionList, setRegionList] = useState([]);
    const [stateList, setStateList] = useState([]);
    const [storeList, setStoreList] = useState([]);
    const [brandNameList, setBrandNameList] = useState([]);
    const [storeNameListForCustom, setStoreNameListForCustom] = useState([]);
    const [inputValue, setInputValue] = useState({
        brand: {},
        store: [],
        region: [],
        state: []
    });
    const [regionListForUpload, setRegionListForUpload] = useState([]);
    const [stateListForUpload, setStateListForUpload] = useState([]);
    const [anchorElForBrand, setAnchorElForBrand] = useState(null);
    const [uploadFileModal, setUploadFileModal] = useState(false);
    const openBrandFilter = Boolean(anchorElForBrand);
    const [anchorElForRegion, setAnchorElForRegion] = useState(null);
    const openRegionFilter = Boolean(anchorElForRegion);
    const [anchorElForState, setAnchorElForState] = useState(null);
    const openStateFilter = Boolean(anchorElForState);
    const [anchorElForStore, setAnchorElForStore] = useState(null);
    const openStoreFilter = Boolean(anchorElForStore);
    const [uploadedFile, setUploadedFile] = useState([]);
    const [progress, setProgress] = useState(25);
    const [uploadSpeed, setUploadSpeed] = useState(null);
    const [startTime, setStartTime] = useState(null);

    const [uploadButtonDisabled, setUploadButtonDisabled] = useState(true);
    const USER_ID = useSelector((state) => state.userAuthentication.userId);
    const USER_TOKEN = useSelector((state) => state.userAuthentication.userToken);
    const dispatch = useDispatch();
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);
    const gridRef = useRef(null);
    const [selectedBrand, setSelectedBrand] = useState({ label: '', value: '' });
    const [selectedRegion, setSelectedRegion] = useState({ label: '', value: '' });
    const [selectedState, setSelectedState] = useState({ label: '', value: '' });
    const [selectedStore, setSelectedStore] = useState({ label: '', value: '' });
    const [dropSearchValue, setdropSearchValue] = React.useState({ brand: '', region: '', state: '', store: '' });
    const handleSearchChange = (event, name) => {
        if (name === 'brand') setdropSearchValue(prev => ({ ...prev, brand: event.target.value }));
        else if (name === 'region') setdropSearchValue(prev => ({ ...prev, region: event.target.value }));
        else if (name === 'state') setdropSearchValue(prev => ({ ...prev, state: event.target.value }));
        else if (name === 'store') setdropSearchValue(prev => ({ ...prev, store: event.target.value }));
    };

    const handleBrandClick = (event) => {
        setAnchorElForBrand(event.currentTarget);
    };
    const handleBrandClose = () => {
        setAnchorElForBrand(null);
    };
    const handleRegionClick = (event) => {
        setAnchorElForRegion(event.currentTarget);
    };
    const handleRegionClose = () => {
        setAnchorElForRegion(null);
    };
    const handleStateClick = (event) => {
        setAnchorElForState(event.currentTarget);
    };
    const handleStateClose = () => {
        setAnchorElForState(null);
    };
    const handleStoreClick = (event) => {
        setAnchorElForStore(event.currentTarget);
    };
    const handleStoreClose = () => {
        setAnchorElForStore(null);
    };

    useEffect(() => {
        getAllBrand();
    }, [])

    useEffect(() => {
        if (defaultBrand.value) getRegionStateStore(defaultBrand.value, selectedRegion.value, selectedState.value);
    }, [defaultBrand, selectedRegion, selectedState])

    useEffect(() => {
        if (inputValue.brand.brand_id) {
            let brands = inputValue.brand.brand_id
            let region = inputValue.region.map(item => item).join(",")
            let state = inputValue.state.map(item => item).join(",")
            getRegionStateStoreForUpload(brands, region, state);
        }
    }, [inputValue])

    useEffect(() => {
        getDashboardData(defaultBrand.value, selectedRegion.value, selectedState.value, selectedStore.value);
    }, [defaultBrand, selectedRegion, selectedState, selectedStore])

    const onClickClear = (filter) => {
        if (filter === 'store') {
            setSelectedStore({ label: '', value: '' })
        } else if (filter === 'state') {
            setSelectedState({ label: '', value: '' })
        } else {
            setSelectedRegion({ label: '', value: '' })
        }
    }

    const getDashboardData = (brand, region, state, store,) => {
        setLoading(true);
        let param = `?brand_id=${brand}&store_region=${region}&store_state=${state}&store_id=${store}`;
        GetReplenishmentFile(param, USER_TOKEN).then(response => {
            let table = [];
            console.log(response)
            response?.data?.data?.map(item => {
                let rowData = {
                    brandN: item?.brand_name || '-',
                    storeN: item?.store_details.map(store => store.customer_name),
                    storeC: item?.store_details.map(store => store.store_code),
                    status: `Broken- ${item?.replanishment_status.broken},
                    Key-${item?.replanishment_status.key},
                    Full-${item?.replanishment_status.full}`,
                    fileLink: item.file_url,
                    id: item._id
                }
                table.push(rowData);
            })
            console.log(table)
            setTableData(table)
        }).catch(error => {

        }).finally(() => {
            setLoading(false);
        })
    }

    const getRegionStateStore = (brand, region, state) => {
        setLoading(true);
        let param = `?store_region=${region}&store_state=${state}&brand_id=${brand}`
        getStockFilterValue(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                let store = []
                response.data.data.store.forEach(element => {
                    let storeObject = {
                        label: checkStoreName(element.store_name, element.store_trade_name),
                        value: element.store_id
                    }
                    store.push(storeObject)
                });
                setStoreList(store);

                let dropdownData = [];
                response.data.data.store.forEach(item => {
                    let row = {
                        label: `${item?.store_name}`,
                        value: item?.store_id,
                        // store_code: item?.store_code,
                        store_id: item?.store_id,
                        store_trade_name: item?.store_trade_name
                    }
                    dropdownData.push(row);
                })
                setStoreNameListForCustom(dropdownData);

                let regions = []
                response.data.data.region.forEach(element => {
                    let regionObj = {
                        label: element.store_region,
                        value: element.store_region
                    }
                    regions.push(regionObj)
                });
                setRegionList(regions);
                let states = []
                response.data.data.state.forEach(element => {
                    let stateObj = {
                        label: element.store_state,
                        value: element.store_state
                    }
                    states.push(stateObj)
                });
                setStateList(states)
            }
        }).catch(error => {
            if (error?.response?.status === 401) {
                history.push('/')
            }
            ToastErrorService(error?.response?.data?.message);
        }).finally(() => {
            setLoading(false);
        })
    }
    const getRegionStateStoreForUpload = (brand, region, state) => {
        setLoading(true);
        let param = `?store_region=${region}&store_state=${state}&brand_id=${brand}`
        getStockFilterValue(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                let dropdownData = [];
                response.data.data.store.forEach(item => {
                    let row = {
                        label: `${item?.store_name}`,
                        value: item?.store_id,
                        // store_code: item?.store_code,
                        store_id: item?.store_id,
                        store_trade_name: item?.store_trade_name
                    }
                    dropdownData.push(row);
                })
                setStoreNameListForCustom(dropdownData);

                let regions = []
                response.data.data.region.forEach(element => {
                    let regionObj = {
                        label: element.store_region,
                        value: element.store_region
                    }
                    regions.push(regionObj)
                });
                setRegionListForUpload(regions);
                let states = []
                response.data.data.state.forEach(element => {
                    let stateObj = {
                        label: element.store_state,
                        value: element.store_state
                    }
                    states.push(stateObj)
                });
                setStateListForUpload(states)
            }
        }).catch(error => {
            if (error?.response?.status === 401) {
                history.push('/')
            }
            ToastErrorService(error?.response?.data?.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    const getAllBrand = () => {
        let param = `?user_id=${USER_ID}`
        GetBrandNameList(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                let brands = []
                response.data.data.forEach(element => {
                    let brandObject = {
                        label: element.brand_name,
                        value: element._id
                    }
                    brands.push(brandObject)
                });
                setBrandList(brands);
                let dropdownData = [];
                response?.data?.data?.forEach(item => {
                    let row = {
                        label: item?.brand_name,
                        value: item?.brand_name,
                        brand_id: item?._id
                    }
                    dropdownData.push(row)
                })
                setBrandNameList(dropdownData);
                if (!defaultBrand.value) dispatch(stockActions.setDefaultBrand({ type: { label: brands[0]?.label, value: brands[0]?.value } }));
                setSelectedBrand({ label: brands[0]?.label, value: brands[0]?.value });
            }
        }).catch(error => {
            if (error.response.status === 401) {
                history.push('/')
            }
            ToastErrorService(error.response.data.message);
        }).finally(() => {
        })
    }

    const onSelectBrand = (event) => {
        brandList.forEach(brand => {
            if (event.target.value === brand?.value) {
                setSelectedBrand({ label: brand?.label, value: event.target.value })
                setAnchorElForBrand(null);
                dispatch(stockActions.setDefaultBrand({ type: { label: brand?.label, value: event.target.value } }));
            }
        });
        setSelectedState({ label: '', value: '' })
        setSelectedStore({ label: '', value: '' })
        setSelectedRegion({ label: '', value: '' })
    }
    const onSelectRegion = (event) => {
        regionList.forEach(region => {
            if (event.target.value === region?.value) {
                setSelectedRegion({ label: region?.label, value: event.target.value })
                setAnchorElForRegion(null);
            }
        });
        setSelectedState({ label: '', value: '' })
        setSelectedStore({ label: '', value: '' })
    }
    const onSelectState = (event) => {
        stateList.forEach(state => {
            if (event.target.value === state?.value) {
                setSelectedState({ label: state?.label, value: event.target.value })
                setAnchorElForState(null);
            }
        });
        setSelectedStore({ label: '', value: '' })
    }
    const onSelectStore = (event) => {
        storeList.forEach(store => {
            if (event.target.value === store?.value) {
                setSelectedStore({ label: store?.label, value: event.target.value })
                setAnchorElForStore(null);
            }
        });
    }

    const onClickDownload = () => {
        downloadReport(defaultBrand?.value)
    }
    const onClickUpload = () => {
        setUploadFileModal(prev => !prev)
        setInputValue({
            brand: {},
            store: [],
            region: [],
            state: []
        })
        setUploadedFile([])
    }

    const checkStoreName = (storeName, storeTradeName) => {
        if (storeTradeName && storeTradeName !== 'null') {
            return storeTradeName
        } else {
            return storeName
        }
    }

    const downloadReport = (brand) => {
        setLoading(true);
        let param = `?brand_id=${brand}`;
        DownlaodStockBrokenSizeReport(param, USER_TOKEN).then(response => {
            window.open(response.data.url, '_blank');
            if (response?.data?.buffer?.statusCode === 400) {
                ToastErrorService(response?.data?.buffer?.message);
            } else {
                ToastSuccessService('Template downloaded successfully.');
            }
        }).catch(error => {
            ToastErrorService(error?.response?.data?.message)
        }).finally(() => {
            setLoading(false);
        })
    }

    const createBrandWiseTotalRow = () => {
        return;
    }

    const onGridReady = (params) => {
        gridRef.current = params.api;
        gridRef.current.sizeColumnsToFit();
    };

    const submitFile = () => {
        const formData = new FormData();
        formData.append('brand_data', JSON.stringify({ brand_id: inputValue.brand.brand_id, brand_name: inputValue.brand.value }))
        formData.append('region', JSON.stringify(inputValue.region))
        formData.append('state', JSON.stringify(inputValue.state))
        let newStores = []
        inputValue.store.forEach(item => {
            newStores.push({ store_id: item.store_id })
        })
        formData.append('store_details', JSON.stringify(newStores))
        formData.append('file', uploadedFile)
        fileSubmitted(formData)
    }

    const fileSubmitted = (formData) => {
        setLoading(true)
        UploadBrokenSizeFile(formData, USER_TOKEN).then(response => {
            ToastSuccessService(response.data.message)
            setUploadFileModal(false)
        }).catch(error => {
            ToastErrorService(error?.response?.data?.message)
        }).finally(() => {
            setLoading(false)
        })
    }

    const onSelectValue = (event, name) => {
        const {
            target: { value },
        } = event;
        if (name === 'store') {
            let storeObject = [];
            let storeIds = [];
            value.map(storeName => {
                const selectedStore = storeNameListForCustom?.find(store => store?.value === storeName);
                let storeSelected = {
                    store_id: selectedStore?.store_id,
                    store_trade_name: selectedStore?.store_trade_name !== 'null' ? selectedStore?.store_trade_name : selectedStore?.label,
                    store_code: selectedStore?.store_code,
                    store_name: selectedStore?.label
                }
                storeObject.push(storeSelected);
                storeIds.push(selectedStore?.store_id);
            }).filter(storeName => storeName);
            setInputValue(values => ({
                ...values, 'store': storeObject,
            }));

        } else if (name === 'brand') {
            let brandObject = [];
            value.map(brandName => {
                const selectedBrand = brandNameList?.find(brand => brand?.value === brandName);
                let brandSelected = {
                    brand_name: selectedBrand?.label,
                    brand_id: selectedBrand?.brand_id
                }
                brandObject.push(brandSelected);
            }).filter(brand => brand);
            setInputValue(values => ({
                ...values, 'brand': brandObject, store: []
            }));
        } else if (name === 'region') {
            setInputValue(values => ({
                ...values, 'region': value, store: []
            }));
        } else if (name === 'state') {
            setInputValue(values => ({
                ...values, 'state': value, store: []
            }));
        }
    }

    const handleFileDrop = (files) => {
        const fileUploaded = files[0];
        if (fileUploaded) {
            setUploadedFile(fileUploaded);
            setProgress(0);
            simulateUpload();
        }
    };

    const simulateUpload = () => {
        setUploadButtonDisabled(true);
        const interval = setInterval(() => {
            setProgress((prevProgress) => {
                const nextProgress = prevProgress + 25;
                if (nextProgress >= 100) {
                    clearInterval(interval);
                    setUploadSpeed(null);
                    setUploadButtonDisabled(false);
                    return 100;
                }
                if (!startTime) {
                    setStartTime(Date.now());
                }
                const elapsedTime = (Date.now() - startTime) / 1000; // in seconds
                const speed = (nextProgress / elapsedTime).toFixed(2); // in % per second
                setUploadSpeed(speed);
                return nextProgress;
            });
        }, 500);
    };

    const removeFile = () => {
        setUploadedFile([]);
    }

    const onBrandSelection = (e, value) => {
        setInputValue(values => ({
            ...values, 'brand': value, store: []
        }));
    }

    const onClickDownloadReport = (params) => {
        generatePreSignedUrl(params.data.id)
    }

    const generatePreSignedUrl = (id) => {
        let param = `?id=${id}`
        DownloadConsolidatedReportList(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                window.open(response.data.presignedFileUrl, '_blank');
                ToastSuccessService('Report downloaded successfully.');
            } else if (response.data.statusCode === 400) {
                ToastErrorService(response.data.message);
            }
        }).catch(error => {
            ToastErrorService(error?.response.data.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    const onClickAllStoreDownload = () => {
        let param = `?service_type=broken&brand_id=${defaultBrand?.value}`
        DownloadConsolidatedReportList(param, USER_TOKEN).then(response => {
            if (response.data.statusCode === 200) {
                window.open(response.data.presignedFileUrl, '_blank');
                ToastSuccessService('Report downloaded successfully.');
            } else if (response.data.statusCode === 400) {
                ToastErrorService(response.data.message);
            }
        }).catch(error => {
            ToastErrorService(error?.response.data.message);
        }).finally(() => {
            setLoading(false);
        })
    }

    return (
        <div className='dashboard-container'>
            <div className='d-flex justify-content-between filter-cont'>
                <div className='d-flex align-items-center first-filter'>
                    {/* brand filter */}
                    <div className='position-relative min-w-150'>
                        <button className='d-flex textColorGray notoSansFont statusFilter cursorPointer align-items-center justify-content-between me-3'
                            onClick={handleBrandClick}>
                            <p className='text-truncate' title={defaultBrand.label}>{defaultBrand?.label}</p>
                            <img className={`${openBrandFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                        </button>
                        <CustomFilterSearchDropdown data={brandList} handleClose={handleBrandClose} open={openBrandFilter} anchorEl={anchorElForBrand}
                            onChange={onSelectBrand} selectedValue={defaultBrand?.value} category={'Brand'}
                            dropSearchValue={dropSearchValue.brand} handleSearchChange={(e) => handleSearchChange(e, 'brand')} setdropSearchValue={setdropSearchValue} />
                    </div>
                    {/* region filter  */}
                    <div className='position-relative min-w-150'>
                        <button className='d-flex textColorGray notoSansFont statusFilter cursorPointer align-items-center justify-content-between me-3'
                            onClick={handleRegionClick}>
                            <p className='text-truncate' title={selectedRegion.label}>{selectedRegion?.label === '' ? 'Select Region' : selectedRegion?.label}</p>
                            <img className={`${openRegionFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                        </button>
                        <CustomFilterSearchDropdown onClickClear={() => onClickClear('region')} data={regionList} handleClose={handleRegionClose} open={openRegionFilter} anchorEl={anchorElForRegion}
                            onChange={onSelectRegion} selectedValue={selectedRegion?.value} category={'Region'}
                            dropSearchValue={dropSearchValue.region} handleSearchChange={(e) => handleSearchChange(e, 'region')} setdropSearchValue={setdropSearchValue} />
                    </div>
                    {/* state filter  */}
                    <div className='position-relative min-w-150'>
                        <button className='d-flex textColorGray notoSansFont statusFilter cursorPointer align-items-center justify-content-between me-3'
                            onClick={handleStateClick}>
                            <p className='text-truncate' title={selectedState.label}>{selectedState?.label === '' ? 'Select State' : selectedState?.label}</p>
                            <img className={`${openStateFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                        </button>
                        <CustomFilterSearchDropdown onClickClear={() => onClickClear('state')} data={stateList} handleClose={handleStateClose} open={openStateFilter} anchorEl={anchorElForState}
                            onChange={onSelectState} selectedValue={selectedState?.value} category={'Brand'}
                            dropSearchValue={dropSearchValue.state} handleSearchChange={(e) => handleSearchChange(e, 'state')} setdropSearchValue={setdropSearchValue} />
                    </div>
                    {/* store filter  */}
                    <div className='position-relative min-w-150'>
                        <button className='d-flex textColorGray notoSansFont statusFilter cursorPointer align-items-center justify-content-between me-3'
                            onClick={handleStoreClick}>
                            <p className='text-truncate' title={selectedStore.label}>{selectedStore?.label === '' ? 'Select Store' : selectedStore?.label}</p>
                            <img className={`${openStoreFilter ? 'transform180 pe-2' : 'ps-2'}`} src={dropDownIcon} alt="" />
                        </button>
                        <CustomFilterSearchDropdown onClickClear={() => onClickClear('store')} data={storeList} handleClose={handleStoreClose} open={openStoreFilter} anchorEl={anchorElForStore}
                            onChange={onSelectStore} selectedValue={selectedStore?.value} category={'Brand'}
                            dropSearchValue={dropSearchValue.store} handleSearchChange={(e) => handleSearchChange(e, 'store')} setdropSearchValue={setdropSearchValue} />
                    </div>
                </div>
            </div>
            <div className='stock-details'>
                <div className='d-flex justify-content-between'>
                    <div className='fontSize18 montSerratFont textColorBlack'>{selectedBrand?.label} Broken Stock Details
                        <button className='download-btn me-2 fontSize14 ms-2' onClick={onClickAllStoreDownload}>
                            (All Stores) <img src={DownloadIcon} width={24} height={24} alt="" />
                        </button>
                    </div>
                    <div className='d-flex'>
                        {/* <div className='me-2'>
                            <CustomBlueButton onClick={onClickBrokenSize} title={'Broken Size'} />
                        </div> */}
                        <button className='download-btn me-2' title='Template Upload' onClick={onClickUpload}>
                            <img src={ImportIcon} width={24} height={24} alt="" />
                        </button>
                        <button className='download-btn' title='Template Download' onClick={onClickDownload}>
                            <img src={DownloadIcon} width={24} height={24} alt="" />
                        </button>
                    </div>

                </div>
                <div className='paddingTop16 reports'>
                    <CustomTableWithFilter totalRow={createBrandWiseTotalRow} isContentLeftRightFixed={false} column={StockBrokenSizeHeader} tableRowData={tableData} onGridReady={onGridReady} onClickDownloadReport={onClickDownloadReport} />
                </div>
            </div>

            {/* Upload file modal*/}
            <CustomModal classes="customeProgressModal" open={uploadFileModal} style={uploadedFileModalStyle} handleClose={null}
                content={<div>
                    <div className='d-flex align-items-center'>
                        <div className='montSerratFont fontSize18 textColorBlack position-relative d-flex w-100'>
                            <div>Upload File</div>
                            <button className='uploadFileModalCloseIcon cursorPointer' onClick={() => setUploadFileModal(false)}>
                                <img src={CloseIcon} alt="" />
                            </button>
                        </div>
                    </div>
                    <div className='d-flex paddingTop24 align-items-center justify-content-between'>
                        <div className='d-flex gap-2'>
                            <div style={{ width: '250px' }}>
                                <CustomAutoComplete disabled={false} onChange={onBrandSelection} required options={brandNameList} value={inputValue?.brand.brand_id} label='Brand Name*' />
                            </div>
                            <div style={{ width: '250px' }}>
                                <MultiSelectCheckBox MenuProps={MenuProps} errored={false} errorMsg={''} selectedValue={inputValue?.region?.map(region => region)} handleChange={(e) => onSelectValue(e, 'region')} required options={regionListForUpload} label='Region' />
                            </div>
                            <div style={{ width: '250px' }}>
                                <MultiSelectCheckBox MenuProps={MenuProps} errored={false} errorMsg={''} selectedValue={inputValue?.state?.map(state => state)} handleChange={(e) => onSelectValue(e, 'state')} required options={stateListForUpload} label='State' />
                            </div>
                        </div>
                    </div>
                    <div className='mt-3'>
                        <div style={{ width: '250px' }}>
                            <MultiSelectCheckBox MenuProps={MenuProps} errored={false} errorMsg={''} selectedValue={inputValue?.store?.map(stores => stores?.store_id)} handleChange={(e) => onSelectValue(e, 'store')} required options={storeNameListForCustom} label='Store Name' />
                        </div>
                    </div>
                    <div className='paddingTop24'>
                        <div className='dropZoneContentContainer'>
                            <div className='channelDisplayData'>
                                <CustomDropzone onFileDrop={handleFileDrop} displayContent={<div className='dropZoneContent uploadedFileDropZoneContent'>
                                    <div className='dropZoneInnerContainer'>
                                        <div className='dropZoneImport'>
                                            <img src={ImportIcon} alt="" width={29} height={29} />
                                        </div>
                                    </div>
                                    <div className='paddingTop24'>
                                        <div className='textColorBlack fontSize14 fontMedium'>Drag File to Upload</div>
                                        <div className='textColorGray fontSize12'>Upload Excel & CSV File Only</div>
                                    </div>
                                    <div className='paddingTop24'>
                                        <SecondaryButton onClick={handleFileDrop} title={<span className='fontSemiBold textColorBlue'>Choose File</span>} />
                                    </div>
                                </div>} />
                            </div>
                            <div className='dropZoneContentRight'>
                                {uploadedFile?.path && <div>
                                    <p className='uploadingP'>Uploading</p>
                                    <div className='paddingTop24'>
                                        <ProgressBarForFileUpload onClickImageCloseIcon={removeFile} progress={progress} File={uploadedFile} uploadSpeed={uploadSpeed} />
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                    <div className='paddingTop24 d-flex justify-content-center'>
                        <div className='widthFit'>
                            <CustomBlueButton customCreatePropsBtnClass="custom-close-btn" disabled={!inputValue.brand.brand_id || !uploadedFile.path || uploadButtonDisabled} onClick={submitFile} title={'Submit'} />
                        </div>
                    </div>
                </div>} />

            {/* Loader */}
            {loading && <Loader />}
        </div>
    )
}

export default BrokenSize